export default __webpack_public_path__ + "static/media/House-Big.121f9b6b.png";